import React from 'react';
import { number, bool, string } from 'prop-types';
import { MapStatsUtil } from '../../../utils/map_stats_util';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import LanguageRegionCode from '@alltrails/shared/types/LanguageRegionCode';

const CardLength = ({ length, displayMetric, languageRegionCode }) => {
  if (!length && length !== 0) {
    return null;
  }

  return (
    <span className="xlate-none">
      {StringConstantsMixin.strings.FILTERS.LENGTH}: {MapStatsUtil.metersToFormattedUserUnits(length, 1, displayMetric, languageRegionCode)}
    </span>
  );
};

CardLength.propTypes = {
  length: number,
  displayMetric: bool,
  languageRegionCode: string
};

CardLength.defaultProps = {
  length: 0,
  displayMetric: false,
  languageRegionCode: LanguageRegionCode.English
};

export default CardLength;
